import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { registerUser } from "../services/authService";

export default function RegisterPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    password: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleRegister = async () => {
    if (!form.name || !form.email || !form.mobile || !form.password) {
      return alert("⚠ All fields are required!");
    }
    if (!/^[0-9]{10}$/.test(form.mobile)) {
      return alert("⚠ Please enter a valid 10-digit mobile number.");
    }
    try {
      setLoading(true);

      await registerUser({
        name: form.name.trim(),
        email: form.email.trim(),
        mobile: form.mobile.trim(),
        password: form.password.trim(),
      });

      alert("Registration successfull! Please login.");
      navigate("/login");

    } catch (err) {
      alert(err?.response?.data?.error || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-10 max-w-md mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-center text-blue-700">
        Create Account
      </h1>

      <input
        type="text"
        name="name"
        placeholder="Full Name"
        value={form.name}
        onChange={handleChange}
        className="border p-2 w-full mb-3 rounded"
      />

      <input
        type="email"
        name="email"
        placeholder="Email Address"
        value={form.email}
        onChange={handleChange}
        className="border p-2 w-full mb-3 rounded"
      />

      <input
        type="text"
        name="mobile"
        placeholder="Mobile Number"
        maxLength="10"
        value={form.mobile}
        onChange={handleChange}
        className="border p-2 w-full mb-3 rounded"
      />

      <input
        type="password"
        name="password"
        placeholder="Create Password"
        value={form.password}
        onChange={handleChange}
        className="border p-2 w-full mb-4 rounded"
      />

      <button
        onClick={handleRegister}
        disabled={loading}
        className="bg-green-600 text-white p-2 rounded w-full hover:bg-green-700 disabled:bg-gray-400"
      >
        {loading ? "Registering..." : "Register"}
      </button>

      <p className="text-center text-gray-600 mt-4">
        Already have an account?{" "}
        <Link to="/login" className="text-blue-600 hover:underline">
          Login
        </Link>
      </p>
    </div>
  );
}
